import { render, staticRenderFns } from "./JcdcSessionTimeout.vue?vue&type=template&id=2fefd5ca&scoped=true"
import script from "./JcdcSessionTimeout.vue?vue&type=script&lang=ts"
export * from "./JcdcSessionTimeout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fefd5ca",
  null
  
)

export default component.exports